import { WorkItemResult } from "@buzzeasy/shared-frontend-utilities";
import { Select, theme } from "antd";
import { SearchBar, Space } from "antd-mobile";
import { FC, ReactElement, useMemo } from "react";
import { styled } from "styled-components";
import { HorizontalFlexBox } from "../presenters/TaskListItem";
import { getWorkItemResultIcon } from "../presenters/TaskListItem.utils";

interface IProps {
  onSearch(text: string): void;
  onSearchTextChange(text: string): void;
  onSelectedResultChange(result: string): void;
  selectedResult?: string;
}

const workItemResults: WorkItemResult[] = ["Abandoned", "Cancelled", "Failed", "Handled", "Missed", "Rejected"];

const TaskHistoryFilters: FC<IProps> = ({ onSearch, onSearchTextChange, onSelectedResultChange, selectedResult }) => {
  const { token } = theme.useToken();

  const options: { label: ReactElement; value: string }[] = useMemo(
    () => [
      {
        label: <OptionContainer>All</OptionContainer>,
        value: "all",
      },
      ...workItemResults.map(r => ({
        label: (
          <OptionContainer>
            <HorizontalFlexBox gap={token.sizeXS}>
              {getWorkItemResultIcon(r, token.size)} {r}
            </HorizontalFlexBox>
          </OptionContainer>
        ),
        value: r.toLowerCase(),
      })),
    ],
    [token],
  );

  return (
    <Space direction="vertical" style={{ width: "100%", gap: token.sizeXXS }}>
      <StyledSearchBar
        placeholder="Search by phone number"
        onChange={onSearchTextChange}
        onSearch={onSearch}
        onClear={() => onSearchTextChange("")}
      />
      <Select
        style={{ width: "100%", height: token.controlHeightLG }}
        listHeight={300}
        options={options}
        value={selectedResult ? selectedResult : "all"}
        onChange={value => onSelectedResultChange(value === "all" ? "" : value)}
      />
    </Space>
  );
};

export default TaskHistoryFilters;

const StyledSearchBar = styled(SearchBar)`
  width: 100%;
  --border-radius: ${p => p.theme.borderRadius}px;
  --background: ${p => p.theme.colorBgContainer};
  
  & .adm-search-bar-input-box {
    border: 1px solid ${p => p.theme.colorBorder};
    padding: ${p => p.theme.paddingXXS}px ${p => p.theme.paddingXS}px;
  }

  &.adm-search-bar-active .adm-search-bar-input-box {
    border: 1px solid ${p => p.theme.colorPrimary};
  }
`;

const OptionContainer = styled.div`
  padding: ${p => p.theme.paddingXXS}px 0;
`;
